export default __webpack_public_path__ + "static/cf-marketing-thumb-1400-dc3dd03b18c7c6dc408aced79db7d055.jpg";